import React, { useCallback } from 'react';
import { ModalBody, ModalNext } from '@jutro/components';
import { ViewModelForm } from 'gw-portals-viewmodel-react';
import { useTranslator } from '@jutro/locale';
import metadata from './AdacContactModal.metadata.json5';
import styles from './AdacContactModal.modules.scss';
import messages from './AdacContactModal.messages';
import usePortalModeBasedLabel from '../../hooks/usePortalModeBasedLabel';

function AdacContactModal({
    isOpen,
    onResolve,
    onAfterClose,
}) {
    const translator = useTranslator();

    function handleClose() {
        return onResolve();
    }

    const makeCall = useCallback((event) => {
        event.preventDefault();
        window.location.href = `tel:${translator(messages.telefonNumber)}`;
    }, [translator]);

    const sendEmail = useCallback((event) => {
        event.preventDefault();
        window.location.href = `mailto:${translator(messages.emailAdress)}`;
    }, [translator]);

    const resolvers = {
        resolveCallbackMap: {
            makeCall,
            sendEmail
        },
        resolveClassNameMap: styles
    };

    const overrideProps = {
        modalTitle: {
            content: usePortalModeBasedLabel('pageHeaderTitle')
        },
        phoneNumber: {
            content: usePortalModeBasedLabel('telefonNumber')
        },
        email: {
            content: usePortalModeBasedLabel('emailAddress')
        }
    };

    return (
        <ModalNext
            isOpen={isOpen}
            onRequestClose={handleClose}
            onAfterClose={onAfterClose}
        >
            <ModalBody>
                <ViewModelForm
                    overrideProps={overrideProps}
                    uiProps={metadata.pageContent}
                    callbackMap={resolvers.resolveCallbackMap}
                    classNameMap={resolvers.resolveClassNameMap}
                />
            </ModalBody>
        </ModalNext>
    );
}

export default AdacContactModal;
